import {
  getConversaById,
  atualizarStatusConversa,
  atribuirResponsavelConversa,
  adicionarRespostaConversa,
  vincularTicketConversa,
  type ConversaCanal,
  type RespostaConversa,
} from './conversasCanais';
import { registrarAuditoria } from './auditoriaHelpers';

export { getConversaById, atualizarStatusConversa, atribuirResponsavelConversa };
export type { ConversaCanal, RespostaConversa };

export function adicionarRespostaComAuditoriaConversa(
  conversaId: string,
  resposta: Omit<RespostaConversa, 'id' | 'data'>,
  usuarioNome: string,
  usuarioRole: string,
): boolean {
  const ok = adicionarRespostaConversa(conversaId, resposta);
  if (ok) {
    registrarAuditoria(
      'adicionar_resposta',
      'atendimento',
      `Respondeu conversa ${conversaId} via ${resposta.canal_origem}${resposta.interna ? ' (interna)' : ''}`,
      usuarioNome,
      usuarioRole,
      conversaId,
      'conversa',
    );
  }
  return ok;
}

export function atualizarStatusComAuditoriaConversa(
  conversaId: string,
  novoStatus: ConversaCanal['status'],
  usuarioNome: string,
  usuarioRole: string,
): boolean {
  const conversa = getConversaById(conversaId);
  if (!conversa) return false;
  const statusAnterior = conversa.status;
  const ok = atualizarStatusConversa(conversaId, novoStatus);
  if (ok) {
    registrarAuditoria(
      'alterar_status_chamado',
      'atendimento',
      `Alterou status da conversa ${conversaId} de "${statusAnterior}" para "${novoStatus}"`,
      usuarioNome,
      usuarioRole,
      conversaId,
      'conversa',
    );
  }
  return ok;
}

export function atribuirResponsavelComAuditoriaConversa(
  conversaId: string,
  responsavel: string,
  usuarioNome: string,
  usuarioRole: string,
): boolean {
  const conversa = getConversaById(conversaId);
  if (!conversa) return false;
  const respAnterior = conversa.responsavel || 'Não atribuído';
  const ok = atribuirResponsavelConversa(conversaId, responsavel);
  if (ok) {
    registrarAuditoria(
      'atribuir_chamado',
      'atendimento',
      `Atribuiu conversa ${conversaId} para ${responsavel} (anterior: ${respAnterior})`,
      usuarioNome,
      usuarioRole,
      conversaId,
      'conversa',
    );
  }
  return ok;
}

let ticketCounter = 44;

export function gerarTicketAPartirDeConversa(
  conversaId: string,
  usuarioNome: string,
  usuarioRole: string,
): string | null {
  const conversa = getConversaById(conversaId);
  if (!conversa) return null;

  const novoTicketId = `TK-2026-${String(ticketCounter).padStart(4, '0')}`;
  ticketCounter += 1;

  const ok = vincularTicketConversa(conversaId, novoTicketId);
  if (!ok) return null;

  registrarAuditoria(
    'criar_chamado',
    'atendimento',
    `Gerou ticket ${novoTicketId} a partir da conversa ${conversaId} (${conversa.canal} - ${conversa.usuario_nome})`,
    usuarioNome,
    usuarioRole,
    conversaId,
    'conversa',
  );

  return novoTicketId;
}